import { Button, ButtonGroup, Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconWarningFilled } from '@zillow/constellation-icons';

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  /** Absent when the notes are gone, in which case the modal offers the manual form only. */
  onRetry?: () => void;
  isRetrying?: boolean;
};

/** Shown once when the AI draft errors; dismissing either way leaves the manual form in place. */
const AiDraftFailedModal = ({ isOpen, onDismiss, onRetry, isRetrying = false }: Props) => (
  <Modal
    size="sm"
    dividers={false}
    open={isOpen}
    onOpenChange={(open) => !open && onDismiss()}
    header={<Icon render={<IconWarningFilled />} size="md" css={{ color: 'icon.feedback.warning.hero' }} />}
    body={
      <>
        <Heading level={2} textStyle="heading-xs" css={{ marginBottom: 'tightest' }}>
          Property description and amenities selection failed
        </Heading>
        <Paragraph textStyle="body-sm">
          The AI ran into an issue processing your photos and notes.{' '}
          {onRetry
            ? 'You can try again, or write your property description and select amenities manually.'
            : 'Write your property description and select amenities manually.'}
        </Paragraph>
      </>
    }
    footer={
      <ButtonGroup aria-label="Failed draft actions" orientation={{ base: 'vertical', sm: 'horizontal' }}>
        <Button onClick={onDismiss} data-testid="ai-draft-complete-manually">
          Complete manually
        </Button>
        {onRetry && (
          <Button loading={isRetrying} emphasis="filled" onClick={onRetry} data-testid="ai-draft-try-again">
            Try again
          </Button>
        )}
      </ButtonGroup>
    }
  />
);

export default AiDraftFailedModal;
